export function groupConsecutiveBySpeaker(chunks) {
  const grouped = [];
  let currentSpeaker = null;
  let currentText = '';
  let currentStartTime = null; // Store startTime for each group
  let currentEndTime = null; // Store endTime for each group

  for (const chunk of chunks) {
    const speaker = chunk.speaker || 'Unknown';

    if (speaker === currentSpeaker) {
      // same speaker: append text and update endTime
      currentText += ' ' + chunk.text;
      currentEndTime = chunk.endTime;
    } else {
      if (currentSpeaker !== null) {
        // push the completed group, including both startTime and endTime
        grouped.push({
          speaker: currentSpeaker,
          text: currentText.trim(),
          startTime: currentStartTime,
          endTime: currentEndTime,
        });
      }
      // start a new group
      currentSpeaker = speaker;
      currentText = chunk.text;
      currentStartTime = chunk.startTime;
      currentEndTime = chunk.endTime;
    }
  }

  // push the last group if exists
  if (currentSpeaker !== null) {
    grouped.push({
      speaker: currentSpeaker,
      text: currentText.trim(),
      startTime: currentStartTime,
      endTime: currentEndTime,
    });
  }

  return grouped;
}

export function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export function highlightTextReact(text, searchTerm) {
  if (!searchTerm) return [text];
  const escapedTerm = escapeRegExp(searchTerm);
  const regex = new RegExp(escapedTerm, 'gi');
  let lastIndex = 0;
  const result = [];
  let match;
  let key = 0;

  while ((match = regex.exec(text)) !== null) {
    if (match.index > lastIndex) {
      result.push(text.slice(lastIndex, match.index));
    }
    result.push(
      <span
        key={key++}
        style={{
          backgroundColor: 'yellow',
          display: 'inline',
          whiteSpace: 'normal',
        }}
      >
        {match[0]}
      </span>
    );
    lastIndex = regex.lastIndex;
  }
  if (lastIndex < text.length) {
    result.push(text.slice(lastIndex));
  }
  return result;
}
